module.exports = __webpack_public_path__ + "static/media/sustach-vanesa.009d2940.jpg";